import TourVideoModal from '@/layout/Help/TourVideoModal';
import type { StillStuckItem, StillStuckProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { useHelpEvent, useHelpTourVideo } from '../../hooks';
import StillStuckCard from '../StillStuckCard/StillStuckCard';

// Owns its own actions (tour modal, chat, email). The only thing it can't do
// alone is open the assistant view, which lives in the panel's nav stack.
const StillStuck = ({ items, onOpenAssistant, aiEnabled }: StillStuckProps) => {
  const { open, videoSrc, openTour, closeTour } = useHelpTourVideo();
  const trackEvent = useHelpEvent();

  const handleSelect = (item: StillStuckItem) => {
    if (item.id === 'tour') {
      trackEvent({ event: 'help_tour_open' });
      const _ = openTour();
    } else if (item.id === 'assistant') {
      onOpenAssistant();
    } else if (item.id === 'chat') {
      trackEvent({ event: 'help_support_chat' });
      window.openZoomlogiChat?.();
    } else if (item.id === 'email' && item.copy_value) {
      const subject = encodeURIComponent('Zoomlogi support request');
      const body = encodeURIComponent('Please describe your issue:\n\n');
      window.location.href = `mailto:${item.copy_value}?subject=${subject}&body=${body}`;
    }
  };

  return (
    <section className={styles.stillStuck}>
      <h2 className={styles.stillStuckTitle}>Still stuck?</h2>

      <div className={styles.stillStuckList}>
        {items.map(
          (item) =>
            // PRD: the assistant card is hidden when the AI toggle is off.
            (item.id !== 'assistant' || aiEnabled) && (
              <StillStuckCard
                key={item.id}
                item={item}
                onSelect={handleSelect}
              />
            )
        )}
      </div>

      <TourVideoModal
        open={open}
        onClose={closeTour}
        videoSrc={videoSrc}
        title='Watch 5 min tour'
      />
    </section>
  );
};

export default StillStuck;
